import { Primary } from '@cinch-labs/design-system'
import { storyblokEditable } from '@cinch-nx/data-storyblok'
import renderWithResolver from '@cinch-nx/landing-ui-shared/lib/rich-text-renderer/rich-text-renderer'
import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'

import { Intro as PartnershipsIntro } from '../../partnerships/types/partnerships-page'
import styles from './intro.module.css'

const Intro: React.FC<PartnershipsIntro> = (blok) => {
  const { trackEvent } = useAnalytics()
  const [CTA] = blok.CTA || []
  // Doing this because it complains if we add target directly, however it works
  const link = {
    target: '_blank',
  }

  return (
    <div {...storyblokEditable(blok)} className={styles.container}>
      {renderWithResolver(blok.body)}
      {CTA ? (
        <Primary
          element="a"
          {...link}
          href={CTA.url}
          onClick={() => {
            trackEvent({
              eventName: `Partnerships - cinch presents site click`,
              data: {
                event: {
                  name: 'click',
                  category: 'parnerships pages',
                  action: 'partnerships tags',
                  label: `Visit cinch presents site`,
                },
              },
              type: TrackingEventTypes.ADOBE,
            })
          }}
          classNames={{ button: styles.button }}
        >
          {CTA.text}
          {/* <SvgIcon name="external-link" size={16} className={styles.externalIconSvg} /> */}
        </Primary>
      ) : null}
    </div>
  )
}

export default Intro
